import { createSvgIcon } from "@mui/material";

const SignOutIcon = createSvgIcon(
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.75 13.751C1.3375 13.751 0.98425 13.6042 0.69025 13.3107C0.39675 13.0167 0.25 12.6635 0.25 12.251V9.25098H1.75V12.251H12.25V1.75098H1.75V4.75098H0.25V1.75098C0.25 1.33848 0.39675 0.985226 0.69025 0.691226C0.98425 0.397726 1.3375 0.250977 1.75 0.250977H12.25C12.6625 0.250977 13.0157 0.397726 13.3097 0.691226C13.6033 0.985226 13.75 1.33848 13.75 1.75098V12.251C13.75 12.6635 13.6033 13.0167 13.3097 13.3107C13.0157 13.6042 12.6625 13.751 12.25 13.751H1.75Z"/>
    <path d="M5.125 10.751L6.175 9.66348L4.2625 7.75098H10.75V6.25098H4.2625L6.175 4.33848L5.125 3.25098L1.375 7.00098L5.125 10.751Z"/>
  </svg>,
  'SignOut',
);
export default SignOutIcon;
